import { cn } from '@/lib/utils';

interface ClientAcceptanceBrandBarProps
  extends React.HTMLAttributes<HTMLDivElement> {
  bookingCode: string;
}

/** Ciemny pasek strony klienta: marka i kod rezerwacji, nic klikalnego. */
const ClientAcceptanceBrandBar = ({
  bookingCode,
  className,
  ...props
}: ClientAcceptanceBrandBarProps) => (
  <div
    className={cn(
      '@max-[700px]:px-4 flex items-center gap-3 bg-ink px-[26px] py-5 text-basic-white',
      className,
    )}
    {...props}
  >
    <span className="text-base font-extrabold tracking-[-.01em]">Campdesk</span>
    <span className="@max-[700px]:ml-0 @max-[700px]:text-center ml-auto text-[13px] text-neutral-400">
      {bookingCode}
    </span>
  </div>
);

export default ClientAcceptanceBrandBar;
